import React from 'react';
import PublicationStat from './PublicationStat/PublicationStat';

export default function PublicationReaderStat({ readerCount }) {
  return (
    <PublicationStat
      value={readerCount}
      caption="Readers"
      tip="Mendeley users who have this article in their library."
      data-name="reader-stat"
    />
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/PublicationReaderStat.js